namespace app.pesquisaAvancada {
    "use strict";
    import IDirective = angular.IDirective;
    import IDirectiveFactory = angular.IDirectiveFactory;

    class CriteriaSummaryDirective implements IDirective {

        public restrict: string = "E";
        public scope: Object = {
            criteria: "="
        };
        public templateUrl: string = "app/main/pesquisa-avancada/directives/criteria-summary/criteria-summary.html";

        public static factory(): IDirectiveFactory {
            return () => new CriteriaSummaryDirective();
        }
    }

    angular
        .module("app.pesquisa-avancada")
        .directive("criteriaSummary", CriteriaSummaryDirective.factory());
}